export default __webpack_public_path__ + "locales/si/PeopleTranslations.json?hash=f4a626d2861439c14c4da14e5e6a1718";